import { actionButtonClicked } from '@wix/bi-logger-members-app-uou/v2';
import { useBi } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import type { FC } from 'react';
import React, { useRef } from 'react';

import { ABOUT_SECTION_TITLE_ID } from '../../../../../constants';
import { useModal } from '../../../../../contexts/modals';
import { useMember } from '../../../../../contexts/widgets';
import { DataHook } from '../../../../../types';
import EmptyEditor from './EmptyEditor';
import { classes, st } from './OldAbout.st.css';

const AboutEditModal = loadable(() => {
  return import(
    /* webpackChunkName: "AboutEditModal" */ '../../common/AboutEditModal'
  );
});

const Viewer = loadable(
  () => import(/* webpackChunkName: "Viewer" */ './Viewer'),
);

type OldAboutProps = {
  shouldAllowEdit: boolean;
  isEmptyState: boolean;
};

export const OldAbout: FC<OldAboutProps> = ({
  shouldAllowEdit,
  isEmptyState,
}) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const bi = useBi();
  const { id } = useMember();
  const { showModal } = useModal();

  const openAboutEditModal = () => {
    const modalWidth = rootRef.current?.offsetWidth
      ? `${rootRef.current.offsetWidth ?? 0}px`
      : '100%';

    bi.report(
      actionButtonClicked({
        action_type: 'about_click',
        formOrigin: 'profile_page',
        member_chosen: id ?? undefined,
      }),
    );
    showModal(AboutEditModal, { width: modalWidth });
  };

  return (
    <div
      ref={rootRef}
      className={st(classes.root, { withHoverColor: shouldAllowEdit })}
    >
      {isEmptyState ? <EmptyEditor /> : <Viewer />}
      {shouldAllowEdit && (
        <button
          className={classes.overlay}
          data-hook={DataHook.AboutOverlay}
          onClick={openAboutEditModal}
          type="button"
          aria-haspopup="dialog"
          aria-labelledby={ABOUT_SECTION_TITLE_ID}
        />
      )}
    </div>
  );
};
